<template>
    <div class="designerpage">

        <hurst-designer-question-door-range v-if="range_panel_required"
                                            :fabricator="fabricator"
                                            v-model:target="door.attr.door_range"
                                            :ranges="ranges"
                                            :defaults="defaults()"
                                            title="Select a Door Collection"
                                            :reference_on="reference_on"></hurst-designer-question-door-range>

        <div>
            <wb-designer-question-select-door :fabricator="fabricator"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :door-range="door.attr.door_range"
                                              title="Choose Your Door Style"
                                              v-model:target="door.attr.slab"></wb-designer-question-select-door>

            <designer-question-frame-material :slab="door.attr.slab"
                                                 :fabricator="fabricator"
                                                 v-model:target="door.attr.frame_material"></designer-question-frame-material>
        </div>

        <hurst-designer-question-select-frame-style
            :fabricator="fabricator"
            :is-firedoor="is_firedoorrange"
            :type-range="door.attr.door_range"
            v-model:target="door.attr.frame_style"
        ></hurst-designer-question-select-frame-style>

        <hallmark-designer-question-colour-range
            title="Colour Ranges"
            :fabricator="fabricator"
            :type-range="door.attr.door_range"
            v-model:target="door.attr.colour_range"
        ></hallmark-designer-question-colour-range>

        <div class="designeroption">
            <designer-question-opening-direction v-show="technical_should_show" :fabricator="fabricator"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :type-range="door.attr.door_range"
                                                 v-model:target="door.attr.opening_direction"
                                                 :frame-combination="door.attr.frame_style.frame_id"></designer-question-opening-direction>

            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>
            <div v-show="technical_should_show">
                <designer-question-restrictor :fabricator="fabricator"
                                              :slab="door.attr.slab"
                                              :opening-direction="door.attr.opening_direction"
                                              v-model:target="door.attr.restrictor"></designer-question-restrictor>
            </div>
        </div>


        <div class="designeroption" data-designer-component-id="door_colour">
            <h3>Choose Your Door Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               :colour-range="door.attr.colour_range"
                                                               :door-range="door.attr.door_range"
                                                               v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                                  title="External Door Colour"
                                                  v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
                </div>
                <div id="dc-tabs-2">
                    <designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                            :external-colour="door.attr.external_colour"
                                                            :colour-range="door.attr.colour_range"
                                                            :door-range="door.attr.door_range"
                                                            v-model:target="door.attr.door_colour_internal"></designer-question-door-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"
                                                  title="Internal Door Colour"
                                                  v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour">
            <h3>Pick Your Frame Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :colour-range="door.attr.colour_range"
                                                                :door-range="door.attr.door_range"
                                                                v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_external"
                                                  title="External Frame Colour"
                                                  v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>
                </div>
                <div id="tabs-2">
                    <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :colour-range="door.attr.colour_range"
                                                                :door-range="door.attr.door_range"
                                                                v-model:target="door.attr.frame_colour_internal"></wb-designer-question-frame-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_internal"
                                                  title="Internal Frame Colour"
                                                  v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>
                </div>
                <div class="clearfix p-4" v-if="!is_firedoorrange">
                    Frame colour options are grained on the external unless selecting White or Ral Smooth.
                </div>
            </div>
        </div>

        <div v-show="!is_firedoorrange">
            <hurst-designer-question-technical-profile
                :fabricator="fabricator"
                :frame-colour-internal="door.attr.frame_colour_internal"
                :frame-colour-external="door.attr.frame_colour_external"
                :frame-material="door.attr.frame_material"
                :secured-by-design="door.attr.secured_by_design"
                :hardware-handle="door.attr.hardware_handle"
                :hardware-escutcheon="door.attr.hardware_escutcheon"
                :frame-combination="door.attr.frame_style.frame_id"
                :opening-direction="door.attr.opening_direction"
                v-model:target="door.attr.profile"
                title="Select A Frame"
            ></hurst-designer-question-technical-profile>
        </div>

        <div>
            <hurst-designer-question-secured-by-design v-show="!is_timberComposite" v-if="!no_sbd" :fabricator="fabricator"
                                                       :frame-style="door.attr.frame_style"
                                                       :opening-direction="door.attr.opening_direction"
                                                       :hardware-lock="door.attr.hardware_lock"
                                                       :threshold="door.attr.threshold"
                                                       :type-range="door.attr.door_range"
                                                       v-model:target="door.attr.secured_by_design"></hurst-designer-question-secured-by-design>

            <designer-question-door-location :fabricator="fabricator"
                                             v-model:target="door.attr.door_location"></designer-question-door-location>

                <designer-question-door-glass-laminated v-show="!is_firedoorrange"
                                                        :fabricator="fabricator"
                                                        title="Laminated Door Glass:"
                                                        :slab="door.attr.slab"
                                                        :frame-style="door.attr.frame_style"
                                                        :side-panels="door.attr.side_panels"
                                                        :secured-by-design="door.attr.secured_by_design"
                                                        :is-firedoor="is_firedoorrange"
                                                        v-model:target="door.attr.laminated_glass"
                                                        :door_range="door.attr.door_range"
                                                        :door-location="door.attr.door_location"
                ></designer-question-door-glass-laminated>
        </div>

        <div>
            <wb-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"></wb-designer-question-glass-design>

            <designer-question-glass-text v-model:target="door.attr.glass_text"
                                             :glass-design="door.attr.glass_design"
                                          :extra_text="'Font will be Times New Roman and sized to suit.'"
            ></designer-question-glass-text>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <hurst-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                         v-model:target="door.attr.side_panels"
                                                         :door-range="door.attr.door_range"
                                                         :frame-style="door.attr.frame_style"
                                                         :frame-profile="door.attr.profile"
                                                         :frame-material="door.attr.frame_material"
                                                         :laminated-glass="door.attr.laminated_glass"
                                                         :frame-colour-internal="door.attr.frame_colour_internal"
                                                         :frame-colour-external="door.attr.frame_colour_external"
                                                         :external-colour="door.attr.external_colour"
                                                         :door-colour-internal="door.attr.door_colour_internal"
                                                         :secured-by-design="door.attr.secured_by_design"
                                                         :slab="door.attr.slab"
                                                         :measurements.sync="door.attr.measurements"></hurst-designer-question-select-frame-sidepanels>


        <div>
            <wb-designer-question-hardware-colour :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_colour"
                                                  :sbd="door.attr.secured_by_design"
                                                  :slab="door.attr.slab"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"
                                                  :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour>
        </div>
        <div>
            <wb-designer-question-hardware-handle :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :door-range="door.attr.door_range"
                                                  :door-location="door.attr.door_location"
                                                  :profile="door.attr.profile"></wb-designer-question-hardware-handle>

            <wb-designer-question-hardware-handle-internal :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_handle_internal"
                                                           :slab="door.attr.slab"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :opening-direction="door.attr.opening_direction"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :door-range="door.attr.door_range"
                                                           :profile="door.attr.profile"
                                                           :handle-external="door.attr.hardware_handle"></wb-designer-question-hardware-handle-internal>

                <designer-question-hardware-handle-split-spindle v-show="technical_should_show" :fabricator="fabricator"
                                                                 title="Offset (Split spindle type operation): "
                                                                 v-model:target="door.attr.hardware_handle_split_spindle"
                                                                 :hardware-handle="door.attr.hardware_handle"
                                                                 :slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>

            <div v-if="!is_firedoorrange">
                <designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                              v-model:target="door.attr.hardware_decorative_handle"
                                                              :slab="door.attr.slab"
                                                              :hardware-colour="door.attr.hardware_colour"
                                                              :door-range="door.attr.door_range"></designer-question-hardware-decorative-handle>

                <designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                                       v-model:target="door.attr.hardware_decorative_handle_pos"
                                                                       :slab="door.attr.slab"
                                                                       :frame-material="door.attr.frame_material"
                                                                       :hardware-decorative-handle="door.attr.hardware_decorative_handle"></designer-question-hardware-decorative-handle-position>
            </div>
        </div>

        <div>
            <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :hardware-handle-internal="door.attr.hardware_handle_internal"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"
            ></wb-designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"
            ></designer-question-hardware-escutcheon-position>
        </div>

        <div v-show="is_stable">
            <wb-designer-question-hardware-escutcheon-stable :fabricator="fabricator"
                                                             title="Stable Bottom Leaf Escutcheon"
                                                             v-model:target="door.attr.hardware_escutcheon_stable"
                                                             :slab="door.attr.slab"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                             :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-stable>

            <designer-question-hardware-escutcheon-stable-position :fabricator="fabricator"
                                                                   v-model:target="door.attr.hardware_escutcheon_stable_pos"
                                                                   :slab="door.attr.slab"
                                                                   :frame-material="door.attr.frame_material"
                                                                   :hardware-escutcheon="door.attr.hardware_escutcheon_stable"></designer-question-hardware-escutcheon-stable-position>
        </div>
        <div>
            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"
                                                    :door-location="door.attr.door_location"
                                                    title="Choose A Viewer"
            ></wb-designer-question-hardware-spy-hole>

            <wb-designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"></wb-designer-question-hardware-spy-hole-position>

        </div>

        <div>
            <wb-designer-question-hardware-knocker :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"></wb-designer-question-hardware-knocker>

              <designer-question-hardware-knocker-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_knocker_pos"
                                                           :slab="door.attr.slab"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-knocker="door.attr.hardware_knocker"></designer-question-hardware-knocker-position>
        </div>
        <div>
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_letterbox_cowl"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-letterplate="door.attr.hardware_letterbox"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                       :door-location="door.attr.door_location"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"></designer-question-hardware-letterbox-position>
        </div>

        <div v-show="technical_should_show">
            <designer-question-hardware-lock :fabricator="fabricator"
                                             maintitle="Choose Your Lock"
                                             title=""
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :frame-material="door.attr.frame_material"
                                             :hardware-handle="door.attr.hardware_handle"
                                             :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                             :door-location="door.attr.door_location"
                                             :door-range="door.attr.door_range"></designer-question-hardware-lock>

            <designer-question-hardware-cylinder v-show="technical_should_show" :fabricator="fabricator"
                                                    title="Choose Your Cylinder"
                                                    :slab="door.attr.slab"
                                                    v-model:target="door.attr.hardware_cylinder"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :opening_direction="door.attr.opening_direction"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"></designer-question-hardware-cylinder>

            <designer-question-hardware-cylinder-stable v-show="is_stable" :fabricator="fabricator"
                                                           title="Stable Bottom Leaf Cylinder"
                                                           v-model:target="door.attr.hardware_cylinder_stable"
                                                           :slab="door.attr.slab"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :hardware-lock="door.attr.hardware_lock"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :hardware-handle="door.attr.hardware_handle"
                                                           :hardware-cylinder="door.attr.hardware_cylinder"
                                                           :door-range="door.attr.door_range"></designer-question-hardware-cylinder-stable>

            <designer-question-hardware-key
              v-show="technical_should_show"
              :fabricator="fabricator"
              title="Extra Key Blanks"
              v-model:target="door.attr.key"
              :hardware-cylinder="door.attr.hardware_cylinder"
            ></designer-question-hardware-key>

            <designer-question-hardware-key-qty
              v-show="technical_should_show"
              :fabricator="fabricator"
              maintitle="Extra Key Blanks"
              title="How many extra key blanks would you like?"
              v-model:target="door.attr.key_qty"
              :keyAttribute="door.attr.key"
            ></designer-question-hardware-key-qty>
        </div>

        <div v-show="false">
            <wb-designer-question-hardware-joining-bolt :fabricator="fabricator"
                                                        title="Choose your Rack Bolt"
                                                        v-model:target="door.attr.hardware_joining_bolt"
                                                        :slab="door.attr.slab"
                                                        :door-range="door.attr.door_range"
                                                        :hardware-colour="door.attr.hardware_colour"
            ></wb-designer-question-hardware-joining-bolt>

            <designer-question-hardware-joining-bolt-position :fabricator="fabricator"
                                                              v-model:target="door.attr.hardware_joining_bolt_pos"
                                                              :slab="door.attr.slab"
                                                              :frame-material="door.attr.frame_material"
                                                              :hardware-joining-bolt="door.attr.hardware_joining_bolt"></designer-question-hardware-joining-bolt-position>
        </div>

        <div v-show="technical_should_show">
            <designer-question-hardware-numerals :fabricator="fabricator"
                                                 :type-range="door.attr.door_range"
                                                 v-model:target="door.attr.numerals"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 title="Numerals"></designer-question-hardware-numerals>
        </div>
        <div v-show="technical_should_show">
            <wb-designer-question-hardware-hinge :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_hinge"
                                                 :slab="door.attr.slab"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :hinge-side="door.attr.hinge_side"
                                                 :frame-material="door.attr.frame_material"
                                                 :frame-profile="door.attr.profile"
                                                 :door-range="door.attr.door_range"
                                                 :door-location="door.attr.door_location"></wb-designer-question-hardware-hinge>

          <designer-question-hardware-hinge-bolts
              :fabricator="fabricator"
              v-model:target="door.attr.hardware_hinge_bolts"
              :hardware-hinge="door.attr.hardware_hinge"
              :secured-by-design="door.attr.secured_by_design"
              :hardware-colour="door.attr.hardware_colour"
          ></designer-question-hardware-hinge-bolts>
        </div>

        <div>
            <designer-question-hardware-security-chain :fabricator="fabricator"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       v-model:target="door.attr.hardware_security_chain"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                       :door-range="door.attr.door_range"
                                                       :door-location="door.attr.door_location"
                                                       title="Select A Safety Chain"
            ></designer-question-hardware-security-chain>
        </div>

        <div v-if="is_firedoorrange">
            <designer-question-closer :fabricator="fabricator"
                                      maintitle="Choose A Closer"
                                      v-model:target="door.attr.closer"></designer-question-closer>
        </div>

      <designer-question-slab-edge-profile-colour v-show="!is_firedoorrange"
                                                  :fabricator="fabricator"
                                                  v-model:target="door.attr.slab_edge_colour"
                                                  :colour-internal="door.attr.door_colour_internal"
                                                  :colour-external="door.attr.external_colour"
                                                  :hardware-lock="door.attr.hardware_lock"
                                                  :profile="door.attr.profile"
                                                  :slab="door.attr.slab"
                                                  :door-range="door.attr.door_range"
                                                  :maintitle="'Select Slab Edging Strip Colour'">
      </designer-question-slab-edge-profile-colour>

        <div v-show="technical_should_show" v-if="!is_firedoorrange">
            <wb-designer-question-addons :fabricator="fabricator"
                                         v-model:target="door.attr.addons"
                                         :frame-profile="door.attr.profile"
                                         :frame-colour-internal="door.attr.frame_colour_internal"
                                         :frame-colour-external="door.attr.frame_colour_external"
                                         :addon_limit="6"
                                         :extra_text="'Add ons will always be deducted from the height of the toplight or width of the sidelight if selected. If you require otherwise, please state in the notes box.'"
            ></wb-designer-question-addons>
        </div>

        <div v-show="technical_should_show" v-if="is_firedoorrange">
            <wb-designer-question-addons-limit-one :fabricator="fabricator"
                                         v-model:target="door.attr.addons"
                                         :frame-profile="door.attr.profile"
                                         :frame-colour-internal="door.attr.frame_colour_internal"
                                         :frame-colour-external="door.attr.frame_colour_external"
                                         :addon_limit="3"
                                         :extra_text="'Add ons will always be deducted from the height of the toplight or width of the sidelight if selected. If you require otherwise, please state in the notes box.'"
            ></wb-designer-question-addons-limit-one>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-technical-threshold :fabricator="fabricator"
                                                      title="Choose Your Threshold"
                                                      v-model:target="door.attr.threshold"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :opening-direction="door.attr.opening_direction"
                                                      :frame-profile="door.attr.profile"
                                                      :cill="door.attr.cill"
                                                      :door-range="door.attr.door_range"
                                                      :secured-by-design="door.attr.secured_by_design"></wb-designer-question-technical-threshold>

        </div>

        <div class="designeroption" v-show="technical_should_show">
            <h3>Select Any Required Cills</h3>
            <designer-question-technical-cill :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :threshold="door.attr.threshold"
                                              :component_id="'cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill :component_id="'left_cill'" :fabricator="fabricator"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-profile="door.attr.profile"
                                              v-model:target="door.attr.side_panels.left_sill_id"
                                              :title="'Left Sidepanel'"
                                              v-if="left_sill"
            ></designer-question-technical-cill>

            <designer-question-technical-cill :component_id="'right_cill'" :fabricator="fabricator"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-profile="door.attr.profile"
                                              v-model:target="door.attr.side_panels.right_sill_id"
                                              :title="'Right Sidepanel'"
                                              v-if="right_sill"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>
        </div>

        <div>
            <wb-designer-question-door-drip-colour v-show="technical_should_show" :fabricator="fabricator"
                                                   title="Choose Your Weatherbar Colour"
                                                   :external-colour="door.attr.external_colour"
                                                   v-model:target="door.attr.door_drip_colour"
                                                   :door-range="door.attr.door_range"
                                                   :frame-profile="door.attr.profile"></wb-designer-question-door-drip-colour>
        </div>

        <div v-if="is_stable" v-show="false">
            <div class="designeroption" data-designer-component-id="meeting_bar_style">
                <h3>Select Your Stable Meeting Styles</h3>
                <div class="stylesoption">
                    <div class="row">
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Bottom Meeting Style (Outside)"
                                :door-colour="door.attr.external_colour"
                                v-model:target="door.attr.meeting_bar_outside"
                                :frame-profile="door.attr.profile"
                            ></designer-question-meeting-rail-colour>
                        </div>
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Top Meeting Style (Inside)"
                                :door-colour="door.attr.door_colour_internal"
                                v-model:target="door.attr.meeting_bar_inside"
                                :frame-profile="door.attr.profile"
                                :meeting-rail-outside="door.attr.meeting_bar_outside"
                            ></designer-question-meeting-rail-colour>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <wb-designer-question-technical-drainage :fabricator="fabricator"
                                                     v-model:target="door.attr.drainage"
                                                     :cill="door.attr.cill"
                                                     :threshold="door.attr.threshold"></wb-designer-question-technical-drainage>
        </div>

        <div v-show="technical_should_show">
            <hurst-designer-question-measurements title="Enter Your Required Measurements"
                                                  :fabricator="fabricator"
                                                  :slab="door.attr.slab"
                                                  :external-colour="door.attr.external_colour"
                                                  :internal-colour="door.attr.door_colour_internal"
                                                  :frame-profile="door.attr.profile"
                                                  :threshold="door.attr.threshold"
                                                  :frame-id="door.attr.frame_style.frame_id"
                                                  :side-panels="door.attr.side_panels"
                                                  :addons="door.attr.addons"
                                                  :cill="door.attr.cill"
                                                  :hardware-lock="door.attr.hardware_lock"
                                                  :hardware-hinge="door.attr.hardware_hinge"
                                                  :hardware-handle="door.attr.hardware_handle"
                                                  :hardware-knocker="door.attr.hardware_knocker"
                                                  :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                  :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                  :hardware-letterbox="door.attr.hardware_letterbox"
                                                  :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                  v-model:target="door.attr.measurements"
                                                  :door-range="door.attr.door_range"
                                                  :mdd="mdd"
                                                  :technical_should_show="technical_should_show"
            ></hurst-designer-question-measurements>
        </div>

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control"
               value="Retail Door">

      <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>

      <designer-navigation
          v-if="show_navigation"
          :visible_designer_configurator_components="visible_designer_configurator_components"
          transition="designer-navigation"
      ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        computed: {
            is_firedoorrange(){
                return this.door_type === 'fire';
            },
            is_french(){
                return this.door_type === 'french';
            },
            is_stable(){
                return this.door_type === 'stable';
            },
            is_timberComposite(){
                return this.door_type === 'timber-composite';
            },
            no_sbd() {
                return this.door.attr.door_range === 44;
            },
            left_sill() {
              if (this.left_flag_sill) {
                return false;
              }
              return this.door.attr.side_panels !== undefined && this.door.attr.frame_style.checkedPanels.indexOf('left') !== -1
            },
            right_sill() {
              if (this.right_flag_sill) {
                return false;
              }
              return this.door.attr.side_panels !== undefined && this.door.attr.frame_style.checkedPanels.indexOf('right') !== -1
            },
        },
        watch: {
            no_sbd: function (newValue) {
                if (newValue === true) {
                    this.door.attr.secured_by_design = 1;
                }
            }
        },
        methods: {
          defaults() {
            return {
              40: {
                "attr": {
                  "fabricator": 9,
                  "type": 1,
                  "door_range": 40,
                  "colour_range": 5,
                  "door_location": 1,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "frame_material": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "glass_design": 1,
                  "hardware_colour": 17,
                  "hardware_handle": 360,
                  "hardware_hinge": 2969,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 2214,
                  "hardware_cylinder": 837,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 144629723,
                  "threshold": 144629809,
                  "slab_edge_colour": 144630066,
                  "key": 1424,
                  "key_qty": 35,
                  "side_panels": {
                    "left": 1,
                    "right": 1,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "side_panel_text": {"text": "", "position": null}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {
                    "overall_width": null,
                    "overall_height": null,
                    "left_width": null,
                    "right_width": null,
                    "top_box_drop": null
                  },
                  "restrictor": 597,
                  "hardware_handle_split_spindle": 424,
                  "hardware_security_chain": 317,
                }
              },
              41: {
                "attr": {
                  "fabricator": 9,
                  "type": 1,
                  "door_range": 41,
                  "colour_range": 5,
                    "door_location": 1,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "glass_design": 1,
                  "hardware_colour": 17,
                  "hardware_handle": 360,
                  "hardware_hinge": 2969,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 441,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 2214,
                  "hardware_cylinder": 837,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 144629723,
                  "threshold": 144629809,
                  "slab_edge_colour": 144630066,
                  "key": 1424,
                  "key_qty": 0,
                  "side_panels": {
                    "left": 1,
                    "right": 1,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "side_panel_text":{"text":'',"position":null},
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {
                    "overall_width": null,
                    "overall_height": null,
                    "left_width": null,
                    "right_width": null,
                    "top_box_drop": null
                  },
                  "frame_material": 1,
                  "restrictor": 597,
                  "hardware_handle_split_spindle": 424,
                  "hardware_security_chain": 317,
                }
              },
              42: {
                "attr": {
                  "fabricator": 9,
                  "type": 1,
                  "door_range": 42,
                  "colour_range": 5,
                    "door_location": 1,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "glass_design": 1,
                  "hardware_colour": 17,
                  "hardware_handle": 360,
                  "hardware_hinge": 2969,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 19,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 2214,
                  "hardware_cylinder": 837,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 144629723,
                  "threshold": 144629809,
                  "slab_edge_colour": 144630066,
                  "key": 1424,
                  "key_qty": 0,
                  "side_panels": {
                    "left": 1,
                    "right": 1,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "side_panel_text":{"text":'',"position":null},
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {
                    "overall_width": null,
                    "overall_height": null,
                    "left_width": null,
                    "right_width": null,
                    "top_box_drop": null
                  },
                  "frame_material": 1,
                  "restrictor": 597,
                  "hardware_handle_split_spindle": 424,
                  "hardware_security_chain": 317,
                }
              },
              43: {
                "attr": {
                  "fabricator": 9,
                  "type": 1,
                  "door_range": 43,
                  "colour_range": 5,
                  "door_location": 1,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "glass_design": 1,
                  "hardware_colour": 17,
                  "hardware_handle": 360,
                  "hardware_hinge": 2969,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 2214,
                  "hardware_cylinder": 837,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 144629723,
                  "threshold": 144629809,
                  "slab_edge_colour": 144630066,
                  "key": 1424,
                  "key_qty": 0,
                  "side_panels": {
                    "left": 1,
                    "right": 1,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "side_panel_text":{"text":'',"position":null},
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {
                    "overall_width": null,
                    "overall_height": null,
                    "left_width": null,
                    "right_width": null,
                    "top_box_drop": null
                  },
                  "frame_material": 1,
                  "restrictor": 597,
                  "hardware_handle_split_spindle": 424,
                  "hardware_security_chain": 317,
                }
              },
              44: {
                "attr": {
                  "fabricator": 9,
                  "type": 3,
                  "door_range": 44,
                  "colour_range": 5,
                  "door_location": 1,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "glass_design": 1,
                  "hardware_colour": 17,
                  "hardware_handle": 1290,
                  "hardware_hinge": 2969,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 828,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1286,
                  "hardware_cylinder": 841,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 144629723,
                  "threshold": 144629809,
                  "slab_edge_colour": 144630066,
                  "key": 1424,
                  "key_qty": 35,
                  "side_panels": {
                    "left": 1,
                    "right": 1,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "side_panel_text": {"text": "", "position": null}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "frame_material": 1,
                  "restrictor": 597,
                  "hardware_security_chain": 317,
                  "meeting_bar_outside": 1,
                  "meeting_bar_inside": 1,
                  "hardware_escutcheon_stable": 1189,
                  "hardware_escutcheon_stable_pos": 26913,
                  "hardware_joining_bolt": 1285,
                  "hardware_joining_bolt_pos": 37486
                }
              },
              135: {
                "attr": {
                  "fabricator": 9,
                  "type": 1,
                  "door_range": 135,
                  "colour_range": 5,
                  "door_location": 1,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "glass_design": 1,
                  "hardware_colour": 17,
                  "hardware_handle": 360,
                  "hardware_hinge": 2969,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 304,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 2214,
                  "hardware_cylinder": 837,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 144629723,
                  "threshold": 144629809,
                  "slab_edge_colour": 144630066,
                  "keys": {"1424": 0},
                  "side_panels": {
                    "left": 1,
                    "right": 1,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "side_panel_text":{"text":'',"position":null},
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {
                    "overall_width": null,
                    "overall_height": null,
                    "left_width": null,
                    "right_width": null,
                    "top_box_drop": null
                  },
                  "frame_material": 1,
                  "restrictor": 597,
                  "hardware_handle_split_spindle": 424,
                  "hardware_security_chain": 317,
                }
              },
                142: {
                    "attr": {
                        "fabricator": 9,
                        "type": 6,
                        "door_range": 142,
                        "colour_range": 5,
                        "door_location": 2,
                        "frame_colour_external": 1,
                        "door_colour_internal": 1,
                        "frame_material": 3,
                        "door_drip_colour": 59,
                        "external_colour": 1,
                        "frame_colour_internal": 1,
                        "glass_design": 1114,
                        "hardware_colour": 15,
                        "hardware_handle": 3156,
                        "hardware_hinge": 1806,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 2,
                        "slab": 2378,
                        "frame_style": {"frame_id": 31, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 1098,
                        "hardware_cylinder": 2528,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 4221,
                        "threshold": 144627790,
                        "key_qty": 35,
                        "side_panels": {
                            "left": 52,
                            "right": 52,
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "side_panel_text": {"text": "", "position": null}
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {
                            "left": {},
                            "right": {},
                            "top": {},
                            "bottom": {},
                        },
                        "cill": 149,
                        "drainage": 1,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "restrictor": 597,
                        "hardware_security_chain": 913,
                        "slab_edge_colour": 144627840,
                        "closer": 3149,
                        "hardware_spy_hole_pos": 494724
                    }
                },
                143: {
                    "attr": {
                        "fabricator": 9,
                        "type": 6,
                        "door_range": 143,
                        "colour_range": 5,
                        "door_location": 2,
                        "frame_colour_external": 1,
                        "door_colour_internal": 1,
                        "frame_material": 3,
                        "door_drip_colour": 59,
                        "external_colour": 1,
                        "frame_colour_internal": 1,
                        "glass_design": 1114,
                        "hardware_colour": 15,
                        "hardware_handle": 3156,
                        "hardware_hinge": 1806,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 2,
                        "slab": 2384,
                        "frame_style": {"frame_id": 31, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 1098,
                        "hardware_cylinder": 2528,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 4221,
                        "threshold": 144627790,
                        "key_qty": 35,
                        "side_panels": {
                            "left": 52,
                            "right": 52,
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "side_panel_text": {"text": "", "position": null}
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {
                            "left": {},
                            "right": {},
                            "top": {},
                            "bottom": {},
                        },
                        "cill": 149,
                        "drainage": 1,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "restrictor": 597,
                        "hardware_security_chain": 913,
                        "slab_edge_colour": 144627840,
                        "closer": 3149,
                        "hardware_spy_hole_pos": 494719
                    }
                },
                177: {
                    "attr": {
                        "fabricator": 9,
                        "type": 8,
                        "door_range": 177,
                        "colour_range": 32,
                        "door_location": 1,
                        "frame_colour_external": 1,
                        "door_colour_internal": 1,
                        "frame_material": 1,
                        "door_drip_colour": 1,
                        "external_colour": 1,
                        "frame_colour_internal": 1,
                        "glass_design": 1,
                        "hardware_colour": 17,
                        "hardware_handle": 360,
                        "hardware_hinge": 2969,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3000,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 1,
                        "hardware_lock": 2214,
                        "hardware_cylinder": 837,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144629723,
                        "threshold": 144629809,
                        "slab_edge_colour": 144630066,
                        "key": 1424,
                        "key_qty": 35,
                        "side_panels": {
                            "left": 1,
                            "right": 1,
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 19,
                            "right_panel_glass_id": 19,
                            "top_panel_glass_id": 19,
                            "side_panel_text": {"text": "", "position": null}
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {
                            "left": {},
                            "right": {},
                            "top": {},
                            "bottom": {},
                        },
                        "cill": 149,
                        "drainage": 1,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "restrictor": 597,
                        "hardware_handle_split_spindle": 424,
                        "hardware_security_chain": 317
                    }
                },
                178: {
                    "attr": {
                        "fabricator": 9,
                        "type": 8,
                        "door_range": 178,
                        "colour_range": 32,
                        "door_location": 1,
                        "frame_colour_external": 1,
                        "door_colour_internal": 1,
                        "door_drip_colour": 1,
                        "external_colour": 1,
                        "frame_colour_internal": 1,
                        "glass_design": 1,
                        "hardware_colour": 17,
                        "hardware_handle": 360,
                        "hardware_hinge": 2969,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 2997,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 1,
                        "hardware_lock": 2214,
                        "hardware_cylinder": 837,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144629723,
                        "threshold": 144629809,
                        "slab_edge_colour": 144630066,
                        "key": 1424,
                        "key_qty": 35,
                        "side_panels": {
                            "left": 1,
                            "right": 1,
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 19,
                            "right_panel_glass_id": 19,
                            "top_panel_glass_id": 19,
                            "side_panel_text": {"text": "", "position": null}
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {
                            "left": {},
                            "right": {},
                            "top": {},
                            "bottom": {},
                        },
                        "cill": 149,
                        "drainage": 1,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "frame_material": 1,
                        "restrictor": 597,
                        "hardware_handle_split_spindle": 424,
                        "hardware_security_chain": 317
                    }
                },
                179: {
                    "attr": {
                        "fabricator": 9,
                        "type": 8,
                        "door_range": 179,
                        "colour_range": 32,
                        "door_location": 1,
                        "frame_colour_external": 1,
                        "door_colour_internal": 1,
                        "door_drip_colour": 1,
                        "external_colour": 1,
                        "frame_colour_internal": 1,
                        "glass_design": 1,
                        "hardware_colour": 17,
                        "hardware_handle": 360,
                        "hardware_hinge": 2969,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3016,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 1,
                        "hardware_lock": 2214,
                        "hardware_cylinder": 837,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144629723,
                        "threshold": 144629809,
                        "slab_edge_colour": 144630066,
                        "key": 1424,
                        "key_qty": 35,
                        "side_panels": {
                            "left": 1,
                            "right": 1,
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 19,
                            "right_panel_glass_id": 19,
                            "top_panel_glass_id": 19,
                            "side_panel_text": {"text": "", "position": null}
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {
                            "left": {},
                            "right": {},
                            "top": {},
                            "bottom": {},
                        },
                        "cill": 149,
                        "drainage": 1,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "frame_material": 1,
                        "restrictor": 597,
                        "hardware_handle_split_spindle": 424,
                        "hardware_security_chain": 317
                    }
                },
                180: {
                    "attr": {
                        "fabricator": 9,
                        "type": 3,
                        "door_range": 180,
                        "colour_range": 32,
                        "door_location": 1,
                        "frame_colour_external": 1,
                        "door_colour_internal": 1,
                        "door_drip_colour": 1,
                        "external_colour": 1,
                        "frame_colour_internal": 1,
                        "glass_design": 1,
                        "hardware_colour": 17,
                        "hardware_handle": 1290,
                        "hardware_hinge": 2969,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3062,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 1,
                        "hardware_lock": 1286,
                        "hardware_cylinder": 841,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144629723,
                        "threshold": 144629809,
                        "slab_edge_colour": 144630066,
                        "key": 1424,
                        "key_qty": 35,
                        "side_panels": {
                            "left": 1,
                            "right": 1,
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 19,
                            "right_panel_glass_id": 19,
                            "top_panel_glass_id": 19,
                            "side_panel_text": {"text": "", "position": null}
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 149,
                        "drainage": 1,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "frame_material": 1,
                        "restrictor": 597,
                        "hardware_security_chain": 317,
                        "meeting_bar_outside": 1,
                        "meeting_bar_inside": 1,
                        "hardware_escutcheon_stable": 1189,
                        "hardware_escutcheon_stable_pos": 26913,
                        "hardware_joining_bolt": 1285,
                        "hardware_joining_bolt_pos": 37486
                    }
                }
            };
          },
        }
    }
</script>
